export default __webpack_public_path__ + "static/media/pg-47.0c14264f.jpg";